/**
 * API Configuration - Automatically detects the correct API URL
 * Works for: production, preview, staging, and localhost
 */

// Get the current hostname
const currentHost = typeof window !== 'undefined' ? window.location.hostname : '';

// Determine the correct API URL based on current environment
function getApiUrl() {
  // If we're on localhost (development), use env variable or localhost
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return process.env.REACT_APP_BACKEND_URL 
      ? `${process.env.REACT_APP_BACKEND_URL}/api`
      : 'http://localhost:8001/api';
  }
  
  // For ALL other environments (production, preview, staging)
  // Use the same origin - this ensures the app always talks to its own backend
  return `${window.location.origin}/api`;
}

// Export the API URL - this will be used throughout the app
export const API_URL = getApiUrl();

// Also export the base URL (without /api) for other uses
export const BASE_URL = API_URL.replace('/api', '');

// Debug logging removed for production - uncomment for local debugging only
// if (process.env.NODE_ENV === 'development') {
//   console.log('API Config:', { currentHost, apiUrl: API_URL });
// }

export default API_URL;
